
//The Way Of Life Page

$(document).ready(function(){

    let header = document.getElementById("hdrTopBar");
    let sticky = header.offsetTop;
    let headerHeight = $(".header-container").outerHeight();
    
    $(window).scroll( function(){
        stickFunction();
    });
    
    const stickFunction = () => {
        if (window.pageYOffset > sticky) {
            header.classList.add("sticky");
            $(".stick").css("top", headerHeight);
        } else {
            header.classList.remove("sticky");
        }
    }

    $(window).scroll( function(){/* Every time the window is scrolled ... */
        $('.hide-me').each( function(i){/* Check the location of each desired element */
            var bottom_of_object = $(this).offset().top + 25;
            var bottom_of_window = $(window).scrollTop() + $(window).height();
            if( bottom_of_window > bottom_of_object ){/* If the object is completely visible in the window, fade it it */
                $(this).addClass("fade-in-wol");
            }
        });
    });

    $('.page-wol-endorsements-slick').slick({
        draggable: true,  
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        speed: 3000,
        infinite: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1,
        touchThreshold: 100,
        pauseOnFocus: false,
        pauseOnHover: false
    });

});
